import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDragHandleVertical$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDragHandleVertical extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '252f645e98a62dcc7cc76d7d91a1f1a44a0ef7f5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f4d87ce1f19d95472f915333545e19888cf2710d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c7692a2bb14372ec3e6f275751cfea9ca32e40e4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.173 6.667a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667M6.84 11a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0m5.667 0a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0m0-5.667a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0M13.84 18a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667m-7-1.333a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-drag-handle-vertical", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-drag-handle-vertical"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-drag-handle-vertical":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDragHandleVertical$1);
            }
            break;
    } });
}

const CosmosIconDragHandleVertical = CosmosIconDragHandleVertical$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDragHandleVertical, defineCustomElement };
